import { render, staticRenderFns } from "./btnExcluir.vue?vue&type=template&id=25bb65b0&"
import script from "./btnExcluir.vue?vue&type=script&lang=ts&"
export * from "./btnExcluir.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports